export { Retails } from './components/Retails';
export { RetailsPlaceholder } from './components/RetailsPlaceholder';
